import * as PIXI from 'pixi.js-legacy';
import productService from '../../services/products';
import DynamicProppingAncestor from '../DynamicProppingAncestor';
import InnerDropArea from '../InnerDropArea';
import constants from '../../settings/constants';
import productsService from '../../services/products';
import geometry from '../util/geometry';
import { ITEMS } from '../../constants';

export default class Frame extends DynamicProppingAncestor {
  constructor(args) {
    super(args);
    this.skipSprites = [];
  }

  draw() {
    const { item, ratio } = this;
    const { outerSize, scaledVertices } = this.data;
    const postWidth = productService.getPostWidth();

    this.visible = !item.hidden;

    const textures = {
      front:
        PIXI.Loader.shared.resources[
          `${this.item.modelid.substring(
            this.item.modelid.indexOf(ITEMS.FRAME)
          )}_front_${this.item.filter.color}`
        ].texture,
      back: PIXI.Loader.shared.resources[
        `${this.item.modelid.substring(
          this.item.modelid.indexOf(ITEMS.FRAME)
        )}_back_${this.item.filter.color}`
      ].texture,
      backCover:
        PIXI.Loader.shared.resources[
          `cover${this.item.modelid.substring(
            this.item.modelid.indexOf(ITEMS.FRAME) + ITEMS.FRAME.length
          )}_back`
        ].texture,
      frontCover:
        PIXI.Loader.shared.resources[
          `cover${this.item.modelid.substring(
            this.item.modelid.indexOf(ITEMS.FRAME) + ITEMS.FRAME.length
          )}_front`
        ].texture,
    };

    const hasCover =
      (item.items && item.items.find(item => item.filter.type === 'cover')) ||
      (this.childrenContainer &&
        this.childrenContainer.children.some(
          child => child.item.filter.type === 'cover'
        ));

    this.legsContainer = this.legsContainer || new PIXI.Container();
    this.legsContainer.x = scaledVertices[4][0] - scaledVertices[0][0];

    if (!this.legsContainer.parent) {
      this.addChild(this.legsContainer);
    }

    // Since we cannot use the actual values from the cover model.
    const coverPadding = 25;

    this.backCover = this.backCover || new PIXI.Sprite(textures.backCover);
    this.backCover.height = (outerSize.height + coverPadding / 2) * ratio;
    this.backCover.width = (outerSize.width + coverPadding / 2) * ratio;
    this.backCover.x = -(coverPadding / 2) * ratio;
    this.backCover.y = -(coverPadding / 2) * ratio;
    this.backCover.visible = hasCover;

    if (!this.backCover.parent) {
      this.addChild(this.backCover);
    }

    this.back = this.back || new PIXI.Sprite();
    this.back.texture = textures.back;
    this.back.height = outerSize.height * ratio;
    this.back.width = (outerSize.width - postWidth) * ratio;

    if (!this.back.parent) {
      this.addChild(this.back);
    }

    this.dropAreas = this.dropAreas || new PIXI.Container();
    this.dropAreas.x = scaledVertices[4][0] - scaledVertices[0][0];

    if (!this.dropAreas.parent) {
      this.addChild(this.dropAreas);
    }

    this.rightDropAreas = this.rightDropAreas || new PIXI.Container();
    this.rightDropAreas.x = scaledVertices[4][0] - scaledVertices[0][0];

    if (!this.rightDropAreas.parent) {
      this.addChild(this.rightDropAreas);
    }

    this.childrenContainer = this.childrenContainer || new PIXI.Container();
    this.childrenContainer.x = scaledVertices[4][0] - scaledVertices[0][0];

    if (!this.childrenContainer.parent) {
      this.addChild(this.childrenContainer);
    }

    this.front = this.front || new PIXI.Sprite();
    this.front.texture = textures.front;
    this.front.height = outerSize.height * ratio;
    this.front.width = (outerSize.width - postWidth) * ratio;
    this.front.x = postWidth * ratio;

    if (!this.front.parent) {
      this.addChild(this.front);
    }

    this.frontCover = this.frontCover || new PIXI.Sprite(textures.frontCover);
    this.frontCover.height = (outerSize.height + coverPadding / 2) * ratio;
    this.frontCover.width = (outerSize.width + coverPadding / 2) * ratio;
    this.frontCover.x = -(coverPadding / 2) * ratio;
    this.frontCover.y = -(coverPadding / 2) * ratio;
    this.frontCover.visible = hasCover;

    this.stackContainer = this.stackContainer || new PIXI.Container();
    this.stackContainer.x = scaledVertices[4][0] - scaledVertices[0][0];

    if (!this.stackContainer.parent) {
      this.addChild(this.stackContainer);
    }

    if (!this.frontCover.parent) {
      this.addChild(this.frontCover);
    }

    this.coverDropAreaContainer =
      this.coverDropAreaContainer || new PIXI.Container();
    this.coverDropAreaContainer.x = scaledVertices[4][0] - scaledVertices[0][0];

    if (!this.coverDropAreaContainer.parent) {
      this.addChild(this.coverDropAreaContainer);
    }

    this.rightContainer = this.rightContainer || new PIXI.Container();
    this.rightContainer.x = scaledVertices[4][0] - scaledVertices[0][0];
    if (!this.rightContainer.parent) {
      this.addChild(this.rightContainer);
    }

    this.drawChildren();
  }

  /*
  override item's getcontainer to place outside stuff in correct container
  */
  getContainer(sprite) {
    if (geometry.extendsOutside(sprite.item, this.item, 'x')) {
      return this.rightContainer;
    }
    if (productsService.isType(sprite.item, 'leg')) {
      return this.legsContainer;
    }
    if (
      productsService.isType(sprite.item, [
        ITEMS.FRAME,
        ITEMS.SHELVING_UNIT,
        ITEMS.TOP_SHELF,
      ])
    ) {
      return this.stackContainer;
    }

    return super.getContainer(sprite);
  }

  /*
  override to supply all children for Item.setHitArea
   */
  getAllChildren() {
    return this.childrenContainer.children.concat(
      this.rightContainer.children,
      this.stackContainer.children
    );
  }

  drawDropAreas(slots) {
    slots = slots.filter(slot => slot.parent.itemid === this.item.itemid);

    if (
      slots.length &&
      !slots.every(slot => slot.filter.type === 'cover') &&
      this.backCover &&
      this.frontCover
    ) {
      this.backCover.alpha = constants.DEFAULT_TRANSPARENCY_ALPHA;
      this.frontCover.alpha = constants.DEFAULT_TRANSPARENCY_ALPHA;
    }

    const width = Math.floor(this.data.faceSize.width * this.ratio) - 2;
    const localItem = {
      ...this.item,
      x: 0,
      y: 0,
    };

    slots.forEach(slot => {
      const localSlot = { ...slot, ...slot.local };

      if (
        geometry.extendsOutside(localSlot, localItem) &&
        localSlot.y < localItem.height
      ) {
        const width = localSlot.partnerSlot
          ? localSlot.partnerSlot.x + localSlot.partnerSlot.width - slot.x
          : localSlot.width;
        const sprite = new InnerDropArea({
          width: width * this.ratio,
          height: localSlot.height * this.ratio,
          ratio: this.ratio,
          slot: localSlot,
        });

        sprite.slot = localSlot;

        sprite.x = localSlot.x * this.ratio;
        sprite.y =
          (this.item.height - (localSlot.y + localSlot.height)) * this.ratio;

        this.rightDropAreas.addChild(sprite);
      } else {
        const sprite = super.getDropAreaSprite(localSlot, width);

        if (sprite) {
          if (localSlot.filter.type === 'cover') {
            this.coverDropAreaContainer.addChild(sprite);
          } else {
            this.dropAreas.addChild(sprite);
          }
        }
      }
    });
  }

  eraseDropAreas() {
    if (this.backCover && this.frontCover) {
      this.backCover.alpha = 1;
      this.frontCover.alpha = 1;
    }
    this.coverDropAreaContainer.removeChildren();
    this.rightDropAreas.removeChildren();
    this.stackContainer.children.forEach(child => child.eraseDropAreas());
    super.eraseDropAreas();
  }

  displayDropAreas(slot) {
    const localSlot = slot && { ...slot, ...slot.local };

    this.coverDropAreaContainer.children.forEach(dropArea => {
      super.toggleDropAreaVisibility(dropArea, localSlot);
    });
    this.displayDropArea(this.rightDropAreas, slot);
    this.displayDropArea(this.dropAreas, slot);
  }

  addSprite(sprite, slot, tac) {
    let oldParent;
    if (sprite.parentItem && sprite.parentItem.itemid !== slot.parent.itemid) {
      oldParent = this.app.itemContainer.getSprite(sprite.parentItem.itemid);
    }
    super.addSprite(sprite, slot, tac);
    if (sprite.item.filter.type === 'cover') {
      this.draw();
    }
    if (oldParent && oldParent.adaptPropping) {
      oldParent.adaptPropping();
    }

    this.adaptPropping();
  }

  handleOldSprite(sprite) {
    if (sprite.item?.filter.type === 'cover') {
      if (this.backCover) {
        this.backCover.visible = false;
      }
      if (this.frontCover) {
        this.frontCover.visible = false;
      }
    }
    sprite.destroy();
  }
}
